import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'zen-course-table',
  templateUrl: './course-table.component.html',
  styleUrls: ['./course-table.component.scss']
})
export class CourseTableComponent implements OnInit {

  @Input('title') title: string;

  constructor() { }

  ngOnInit(): void {
  }

}
